import { post } from '../../../lib/axios';

const getDocumentPDF = async (identifier) => {
  const response = await post(`/v1/documents/${identifier}/exports/pdf`, {})
  return response;
};

const useDocumentPDFDownload = () => {

  return async (identifier) => {

    const response = await getDocumentPDF(identifier);
    return response;

  }

};

export default useDocumentPDFDownload;

